// src/components/requisiciones/RequisicionTimeline.js
import React, { useState } from 'react';
import { Badge } from 'react-bootstrap';
import moment from 'moment';

const EVENTO_CONFIG = {
  'CREADA':                 { icon: '\uD83D\uDCDD', color: 'secondary', label: 'Creada' },
  'BORRADOR_GUARDADO':      { icon: '\uD83D\uDCBE', color: 'secondary', label: 'Borrador guardado' },
  'EDITADA':                { icon: '\u270F\uFE0F', color: 'info',      label: 'Editada' },
  'ENVIADA_COMERCIAL':      { icon: '\uD83D\uDCE4', color: 'primary',   label: 'Enviada para Aprobaci\u00F3n' },
  'APROBADA_COMERCIAL':     { icon: '\u2705',       color: 'success',   label: 'Aprobada' },
  'RECHAZADA':              { icon: '\u274C',       color: 'danger',    label: 'Rechazada' },
  'PROVEEDOR_AGREGADO':     { icon: '\uD83C\uDFE2', color: 'secondary', label: 'Proveedor Agregado' },
  'PROVEEDOR_ENVIADO':      { icon: '\uD83D\uDCE8', color: 'warning',   label: 'Enviado a Proveedor' },
  'PROVEEDOR_ACCEDIO':      { icon: '\uD83D\uDC41\uFE0F', color: 'info', label: 'Proveedor Accedi\u00f3' },
  // TIN-23: eventos del flujo multi-proveedor
  'PROVEEDOR_ACEPTO':       { icon: '\u2705',       color: 'success',   label: 'Proveedor Acept\u00f3 Invitaci\u00f3n' },
  'PROVEEDOR_RECHAZO':      { icon: '\u274C',       color: 'danger',    label: 'Proveedor Rechaz\u00f3 Invitaci\u00f3n' },
  'COTIZACION_RECIBIDA':    { icon: '\uD83D\uDCC4', color: 'primary',   label: 'Cotizaci\u00f3n Recibida' },
  'PROVEEDOR_SELECCIONADO': { icon: '\uD83C\uDFC6', color: 'warning',   label: 'Proveedor Seleccionado (Ganador)' },
  'PROVEEDOR_DESCARTADO':   { icon: '\u26A0\uFE0F', color: 'secondary', label: 'Proveedor Descartado' },
  'OC_EMITIDA':             { icon: '\uD83D\uDCCB', color: 'warning',   label: 'OC Emitida' },
  'OC_APROBADA':            { icon: '\u2714\uFE0F', color: 'success',   label: 'OC Aprobada' },
  'OC_ENVIADA_PROVEEDOR':   { icon: '\uD83D\uDCE6', color: 'info',      label: 'OC Enviada al Proveedor' },
  'CERTIFICADOS_RECIBIDOS': { icon: '\uD83C\uDFC5', color: 'success',   label: 'Certificados Recibidos' },
  // TIN-23: ciclo de revisi\u00f3n y devoluci\u00f3n
  'PASO_REVISION_ENTREGA':  { icon: '\uD83D\uDD0D', color: 'warning',   label: 'Pas\u00f3 a Revisi\u00f3n Entrega' },
  'RECIBIDA_SATISFACCION':  { icon: '\uD83C\uDF89', color: 'success',   label: 'Recibida a Satisfacci\u00f3n' },
  'DEVUELTA':               { icon: '\u21A9\uFE0F', color: 'danger',    label: 'Devuelta al Proveedor' },
  'CERRADA':                { icon: '\uD83D\uDD12', color: 'dark',      label: 'Cerrada' },
  'ACTUALIZADA':            { icon: '\u270F\uFE0F', color: 'secondary', label: 'Actualizada' },
  'ESTADO_CAMBIADO':        { icon: '\uD83D\uDD04', color: 'info',      label: 'Estado Cambiado' },
};

const MOSTRAR_INICIAL = 5;

const getActorNombre = (actor) => {
  if (!actor) return 'Sistema';
  if (actor.nombreExterno) return actor.nombreExterno;
  if (actor.usuarioId?.nombre)
    return `${actor.usuarioId.nombre}${actor.usuarioId.apellido ? ' ' + actor.usuarioId.apellido : ''}`;
  return 'Sistema';
};

const RequisicionTimeline = ({ timeline = [] }) => {
  const [expandido, setExpandido] = useState(false);

  if (!timeline || timeline.length === 0) {
    return (
      <div className="text-center text-muted py-3">
        <i className="bi bi-info-circle me-2"></i>
        No hay eventos registrados
      </div>
    );
  }

  const invertido = [...timeline].reverse();
  const eventos = expandido ? invertido : invertido.slice(0, MOSTRAR_INICIAL);

  return (
    <div style={{ position: 'relative', paddingLeft: '30px' }}>
      {eventos.map((evento, index) => {
        const config =
          EVENTO_CONFIG[evento.evento] ||
          { icon: '\u2022', color: 'secondary', label: evento.evento || 'Evento' };
        const actorNombre = getActorNombre(evento.actor);

        return (
          <div
            key={index}
            style={{
              position: 'relative',
              padding: '12px 15px',
              borderBottom: index < eventos.length - 1 ? '1px solid #e9ecef' : 'none',
            }}
          >
            {/* Icono emoji lateral */}
            <div style={{ position: 'absolute', left: '-20px', top: '14px', fontSize: '16px' }}>
              {config.icon}
            </div>

            <div className="d-flex justify-content-between align-items-start gap-2">
              <div>
                <Badge bg={config.color} className="me-2">{config.label}</Badge>
                <small className="text-muted">{actorNombre}</small>

                {evento.descripcion && (
                  <p className="mb-0 mt-1 text-muted" style={{ fontSize: '0.85rem' }}>
                    {evento.descripcion}
                  </p>
                )}

                {evento.archivo && (
                  <p className="mb-0 mt-1" style={{ fontSize: '0.82rem' }}>
                    <a href={evento.archivo} target="_blank" rel="noopener noreferrer">
                      <i className="bi bi-paperclip me-1"></i>Ver archivo adjunto
                    </a>
                  </p>
                )}

                {evento.observacion && (
                  <p
                    className="mb-0 mt-1 ps-2"
                    style={{ fontSize: '0.82rem', borderLeft: '3px solid #dee2e6', color: '#6c757d' }}
                  >
                    <i className="bi bi-chat-left-quote me-1"></i>
                    {evento.observacion}
                  </p>
                )}

                {/* TIN-23: observación de DEVUELTA viene en evento.datos.observacion */}
                {evento.datos?.observacion && (
                  <p
                    className="mb-0 mt-1 ps-2"
                    style={{ fontSize: '0.82rem', borderLeft: '3px solid #f8d7da', color: '#842029' }}
                  >
                    <i className="bi bi-chat-left-quote me-1"></i>
                    {evento.datos.observacion}
                  </p>
                )}
              </div>

              <small className="text-muted" style={{ whiteSpace: 'nowrap' }}>
                {moment(evento.fecha).format('DD/MM/YYYY HH:mm')}
              </small>
            </div>
          </div>
        );
      })}

      {timeline.length > MOSTRAR_INICIAL && (
        <div className="text-center py-2">
          <small
            className="text-primary"
            style={{ cursor: 'pointer' }}
            onClick={() => setExpandido(!expandido)}
          >
            {expandido
              ? '\u25B2 Ver menos'
              : `\u25BC Ver ${timeline.length - MOSTRAR_INICIAL} eventos m\u00e1s`}
          </small>
        </div>
      )}
    </div>
  );
};

export default RequisicionTimeline;
